var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6526 4.43473C38.201 2.75654 36.8779 1.4337 35.2 0.981801C32.1344 0.142853 19.8721 0.142853 19.8721 0.142853C19.8721 0.142853 7.61004 0.142853 4.54446 0.949822C2.89884 1.40143 1.54343 2.75683 1.09183 4.43473C0.285156 7.50002 0.285156 13.8571 0.285156 13.8571C0.285156 13.8571 0.285156 20.2462 1.09183 23.2795C1.54373 24.9574 2.86656 26.2806 4.54476 26.7325C7.64232 27.5714 19.8724 27.5714 19.8724 27.5714C19.8724 27.5714 32.1344 27.5714 35.2 26.7645C36.8782 26.3129 38.201 24.9897 38.6529 23.3118C39.4596 20.2462 39.4596 13.8894 39.4596 13.8894C39.4596 13.8894 39.4919 7.50002 38.6526 4.43473Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9678 19.7301L26.1646 13.8572L15.9678 7.98422V19.7301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.6c37ae85ca094be0b63d2c09bbb48ad3.svg";
export { ForwardRef as ReactComponent };